document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('reviews-trustpilot-swiper');
  if (!el || typeof Swiper === 'undefined') return;

  const dots = document.querySelectorAll('.reviews-trustpilot-items-pagination-container .reviews-trustpilot-pagination-dot');
  const dotsBySlide = {};

  dots.forEach(function (dot) {
    const slideIndex = dot.getAttribute('data-slide-index');
    if (!dotsBySlide[slideIndex]) dotsBySlide[slideIndex] = [];
    dotsBySlide[slideIndex].push(dot);
  });
  const VISIBILITY_THRESHOLD = 0.5;

  const swiper = new Swiper('#reviews-trustpilot-swiper', {
    slidesPerView: 'auto',
    // the gap between cards comes from the slides' padding-right in CSS, not
    // from Swiper's margin, so the cards' box-shadow is not clipped
    spaceBetween: 0,
    grabCursor: true,
    watchSlidesProgress: true,
    on: {
      init: function () {
        setActiveDots(this);
      },
      slideChange: function () {
        setActiveDots(this);
      },
      setTranslate: function () {
        setActiveDots(this);
      },
      transitionEnd: function () {
        setActiveDots(this);
      },
      resize: function () {
        setActiveDots(this);
      },
    },
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      const index = parseInt(dot.getAttribute('data-slide-index'), 10);
      swiper.slideTo(index);
    });
  });

  function setActiveDots(swiperInstance) {
    const containerRect = swiperInstance.el.getBoundingClientRect();
    // the slider overflows the viewport on the right, so the visible area is
    // limited by whichever edge comes first
    const visibleLeft = Math.max(containerRect.left, 0);
    const visibleRight = Math.min(containerRect.right, window.innerWidth || containerRect.right);

    swiperInstance.slides.forEach(function (slide, index) {
      const slideDots = dotsBySlide[index];
      if (!slideDots) return;

      // the slide carries the gap as padding, so measure the card inside it
      const card = slide.firstElementChild || slide;
      const slideRect = card.getBoundingClientRect();
      const visibleWidth = Math.min(slideRect.right, visibleRight) - Math.max(slideRect.left, visibleLeft);
      const visibleRatio = slideRect.width > 0 ? Math.max(0, visibleWidth) / slideRect.width : 0;

      slideDots.forEach(function (dot) {
        dot.classList.toggle('active', visibleRatio >= VISIBILITY_THRESHOLD);
      });
    });
  }
});
